import * as React from "react";
import { Tooltip } from "primereact/tooltip";
import { TableColumExtra } from "../interfaces";
import { cn, I18NString, parseTagSanitizeAndWhitelist } from "../../../helpers/Utils";
import { useToggle } from "../../../../hooks/useToggle";

interface DescriptionProps {
	field?: string;
	extra?: TableColumExtra;
	description?: I18NString;
	notification?: I18NString;
	children?: React.ReactNode;
	classNames?: string;
}

export const Description = ({
	field,
	extra,
	notification,
	description,
	children,
	classNames = "",
}: DescriptionProps) => {
	// TODO: После обновления тс-реакт убрать @ts-ignore !!!
	// @ts-ignore
	const ref = React.useRef<HTMLDivElement>(null);
	const [isOpenNotification, toggleIsOpenNotification] = useToggle(false);
	const [isOpenDescription, toggleIsOpenDescription] = useToggle(false);

	return (
		<div
			ref={ref}
			className={cn(`${classNames}`, {
				"tooltip-wrapper": !!extra?.tooltip,
			})}
		>
			{extra?.hint && <div className="alert alert-info hint">{parseTagSanitizeAndWhitelist(extra.hint)}</div>}
			{extra?.tooltip && (
				// @ts-ignore
				// TODO: !!!
				<Tooltip
					className="controls-tooltip modal-tooltip"
					target={`.${field}`}
					at={`.${field}`}
					autoHide={false}
					appendTo={ref?.current}
				>
					<span>{extra.tooltip}</span>
				</Tooltip>
			)}
			<div className="input-group">
				{children}
				{notification && (
					<span onClick={toggleIsOpenNotification} className="input-group-addon btn btn-default">
						<span className="glyphicon glyphicon-info-sign" />
					</span>
				)}
				{description && (
					<span onClick={toggleIsOpenDescription} className="input-group-addon btn btn-default">
						<span className="glyphicon glyphicon-question-sign" />
					</span>
				)}
			</div>

			{notification && isOpenNotification && (
				<div className="alert alert-warning" role="alert">
					{parseTagSanitizeAndWhitelist(notification.ru)}
				</div>
			)}
			{description && isOpenDescription && (
				<div className="alert alert-warning" role="alert">
					{parseTagSanitizeAndWhitelist(description.ru)}
				</div>
			)}
		</div>
	);
};
